module.exports = __webpack_public_path__ + "img/Hero_Image_v2_poster.16399745.png";